import { appClient } from 'src/config/apollo';
import {
    GetAdminInfoDocument,
    GetAdminInfoQuery,
} from 'src/modules/admin/documents/getAdminInfo.generated';
import {
    GetAllReportsAndSectionsDocument,
    GetAllReportsAndSectionsQuery,
    GetAllReportsAndSectionsQueryVariables,
    ReportsAndSectionsFragment,
} from 'src/modules/admin/documents/getAllReportsAndSections.generated';
import { captureException } from 'src/shared/helpers/captureException';

export class AdminService {
    public async fetchAdminInfo(): Promise<GetAdminInfoQuery | null> {
        try {
            const { data } = await appClient.query({
                query: GetAdminInfoDocument,
                fetchPolicy: 'network-only',
            });

            return data;
        } catch (error) {
            captureException(error);
        }
        return null;
    }
    public async fetchReportsInfo(embedDomain: string = ''): Promise<ReportsAndSectionsFragment[]> {
        try {
            const { data } = await appClient.query<
                GetAllReportsAndSectionsQuery,
                GetAllReportsAndSectionsQueryVariables
            >({
                query: GetAllReportsAndSectionsDocument,
                variables: { embedDomain },
                fetchPolicy: 'no-cache',
            });
            const { getAllReportsAndSections: reportsAndSections } = data;

            // Check if the response is an error and if the error field is not empty
            if (reportsAndSections?.__typename === 'PermissionDeniedError') {
                if (reportsAndSections.debug) {
                    captureException(new Error(reportsAndSections.debug));
                }

                throw reportsAndSections.message ?? '';
            }

            if (reportsAndSections?.__typename === 'LookerReportError') {
                throw new Error('LookerReportError');
            }

            if (!reportsAndSections) {
                throw new Error();
            }

            return (
                reportsAndSections.reportsOrSections?.filter(
                    (item): item is ReportsAndSectionsFragment => item != null,
                ) || []
            );
        } catch (error) {
            captureException(error);
            return [];
        }
    }
}
